<template>
  <div class="body">
    <img style="justify-content: center;" src="../../assets/img/404.png" alt="Description" />
  </div>
</template>

<script>
export default {
  name: "no404"
}
</script>

<style scoped>
  .body {
    justify-content: center;
    display: flex;
    /*align-items: center;*/
    /*width: 100vw; !* 视口宽度 *!*/
    /*height: 100vh; !* 视口高度 *!*/
    /*background-image: url('../../assets/img/404.png');*/
    /*background-repeat: repeat; !* 使背景图片重复 *!*/
    /*background-size: contain; !* 调整图片大小以适应容器 *!*/
  }
  .body img {
    max-width: 100%;
    height: auto;
  }
</style>